import React, { useContext } from "react";
import Onboard from "../../components/Onboard";
import { useNavigate } from "react-router-dom";
import AppContext from "../../AppContext";

const OnboardPage = () => {
  const { isAuth } = useContext(AppContext);

  const navigate = useNavigate();

  // * Don't allow unauthed users in
  if (isAuth) {
    navigate("/");
    return;
  }

  return <Onboard navigate={navigate} />;
};

OnboardPage.propTypes = {};

export default OnboardPage;
